// @flow @jsx h

import { h, Component } from 'preact'
import styles from './Overlay.css'
import { bem } from '@nrk/dh-utils'
import { TIERS } from '../../constants/'

type Props = {
  currentTier: string
}

const { TIER_ONE, TIER_TWO, TIER_THREE, TIER_FOUR, TIER_FIVE, TIER_SIX } = TIERS

class Overlay extends Component<Props, {}> {
  shouldComponentUpdate(nextProps: Props) {
    return nextProps.currentTier !== this.props.currentTier
  }
  render() {
    const { currentTier } = this.props
    const modifiers = {
      darkest: currentTier === TIER_ONE,
      'extra-dark': currentTier === TIER_TWO,
      dark: currentTier === TIER_THREE,
      light: currentTier === TIER_FOUR,
      'extra-light': currentTier === TIER_FIVE,
      lightest: currentTier === TIER_SIX
    }
    return <div class={bem(styles['background-overlay'], modifiers)} />
  }
}

export { Overlay }



// WEBPACK FOOTER //
// ./src/v1/components/Background/Overlay.js